import * as React from 'react';
import { useParams } from 'react-router-dom';
import DetailsMainGrid from '../../components/AmlDetailsMain/DetailsMainGrid';
import { rulesEngineGet } from '../../services/rulesEngineClient';
import { getRulesEngineUiMessage } from '../../services/rulesEngineErrors';
import { getRulesEngineOperationUrl } from '../../services/rulesEngineEndpoints';
import { CircularProgress, Box, Alert } from '@mui/material';
import { clearGraphDataCache } from '../../helpers/graphDataCache';
import { canViewTransactionDetails } from '../../helpers/authSession';

export default function Details() {
  const { id } = useParams();
  const canView = canViewTransactionDetails();
  const [transactionData, setTransactionData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState('');

  React.useEffect(() => {
    if (!canView) {
      setTransactionData(null);
      setErrorMessage('Seu perfil não possui permissão para visualizar detalhes da transação.');
      setLoading(false);
      return;
    }

    clearGraphDataCache();

    const fetchTransactionDetails = async () => {
      try {
        setLoading(true);
        setErrorMessage('');

        const transaction = await rulesEngineGet(getRulesEngineOperationUrl(process.env.REACT_APP_API_RULES_URL, id));

        const personDocument = transaction.ordering_id;

        const destinyDocument = transaction.counterparty_id || null;

        const formattedData = {
          origin: transaction.ordering_name || transaction.sender_name || '',
          destiny: transaction.counterparty_name || transaction.recipient_name || '',
          originDocument: personDocument,
          destinyDocument: destinyDocument,
          value: transaction.value || transaction.amount ? `R$ ${transaction.value || transaction.amount}` : '',
          transactioDateTime: transaction.transactioDateTime || transaction.transaction_datetime
            ? new Date(transaction.transactioDateTime || transaction.transaction_datetime).toLocaleString('pt-BR')
            : '',
          countryOrigin: transaction.ordering_location || transaction.origin_location || '',
          destinyOrigin: transaction.counterparty_location || transaction.destination_location || '',
          riskDescription: transaction.riskDescription || transaction.risk_level || '',
          appointments: transaction.alerts_summary?.alerts?.map(alert => alert.description) || [],
          personDocument: personDocument,
          graphData: transaction.graphData || transaction.graph || transaction.network_data || null,
        };

        setTransactionData(formattedData);
      } catch (error) {
        console.error('Erro ao buscar detalhes da transação:', error);
        setTransactionData(null);
        setErrorMessage(getRulesEngineUiMessage(error));
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTransactionDetails();
    }
  }, [canView, id]);

  if (!canView) {
    return (
      <Box sx={{ mx: 2, mt: 2 }}>
        <Alert severity="warning">Seu perfil não possui permissão para visualizar detalhes da transação.</Alert>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {errorMessage ? (
        <Box sx={{ mx: 2, mt: 2, p: 1.5, borderRadius: 1, bgcolor: 'error.light' }}>
          <Box component="span" sx={{ color: 'error.contrastText', fontSize: '0.875rem' }}>
            {errorMessage}
          </Box>
        </Box>
      ) : null}
      <DetailsMainGrid transactionData={transactionData} />
    </>
  );
}
